export default "__VITE_ASSET__DjmOo3cg__"